// extracted by mini-css-extract-plugin
module.exports = {"resourceGrid":"CalendarView_resourceGrid__owOL4"};